import { render } from "./SubscribedProjectManagementSettings.vue?vue&type=template&id=5c2adae0"
import script from "./SubscribedProjectManagementSettings.vue?vue&type=script&lang=js"
export * from "./SubscribedProjectManagementSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__